@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

@mixin history-sidebar-mobile-nav {
  .root {
    width: 100%;
    height: 50px;
    border-right: none;
    padding-top: unset;
    padding-bottom: unset;
    padding-right: 4px;
    position: absolute;
    z-index: var(--z-index-sidebar);
    background-color: var(--background-soft);
    border-bottom: 1px solid var(--border-soft);
    top: 0;
    left: 0;
    right: 0;

    &.isExpanded {
      width: 75%;
      height: 100%;
      border-right: 1px solid var(--border-soft);
    }
  }

  .headerSection {
    display: none;
  }

  .contentSection {
    padding-left: 8px;
  }

  .toggleButtonWrapper {
    padding-top: 8px;
  }

  .mobileButtons {
    display: block;
    width: 100%;
  }

  .backdrop {
    display: none;
    position: fixed;
    inset: 0;
    background-color: var(--background-backdrop);
    z-index: calc(var(--z-index-sidebar) - 1);
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &.isExpanded {
      display: block;
    }
  }
}

.root {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-right: 1px solid var(--border-soft);
  padding: 20px 8px;
  padding-left: 0;
  height: 100%;
  width: 48px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: var(--background-soft);

  &.isExpanded {
    width: 300px;
  }

  @include respond-to('max-sm') {
    width: 100%;
    height: 50px;
    border-right: none;
    padding-top: unset;
    padding-bottom: unset;
    padding-right: 4px;
    position: absolute;
    z-index: var(--z-index-sidebar);
    background-color: var(--background-soft);
    border-bottom: 1px solid var(--border-soft);
    top: 0;
    left: 0;
    right: 0;

    &.isExpanded {
      width: 75%;
      height: 100%;
      border-right: 1px solid var(--border-soft);
    }
  }
}

:global([data-env='teams']) {
  @include history-sidebar-mobile-nav;
}

.headerSection {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  padding-left: 8px;

  &.isExpanded {
    justify-content: space-between;
  }

  @include respond-to('max-sm') {
    display: none;
  }
}

.leftSection {
  display: flex;
  align-items: center;
  gap: 8px;
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.contentSection {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  overflow: auto;
  @include custom-scroll-minimal;

  @include respond-to('max-sm') {
    padding-left: 8px;
  }
}

.buttonsWrapper {
  display: flex;
  flex-direction: column;
  width: auto;

  &.isExpanded {
    width: 100%;
  }
}

.buttonWrapper {
  @include typography-v2-body-sm;
  @include border-radius-r2;
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  height: auto;
  gap: 8px;
  margin-top: 6px;
  color: var(--text-default);
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    background-color: var(--surface-hover);
  }

  &.disabled {
    color: var(--text-disabled);

    &:hover,
    &:focus {
      background-color: var(--background-soft);
    }
  }

  &.active {
    background-color: var(--surface-active);
  }

  [data-button] {
    border: none;
  }
}

.header {
  @include typography-v2-title-base;
  padding-left: 8px;
}

.toggleButtonWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;

  @include respond-to('max-sm') {
    padding-top: 8px;
  }
}

.toggleButton {
  background-color: var(--background-soft);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;

  &:hover,
  &:focus-visible {
    border-color: var(--surface-hover);
    background-color: var(--surface-hover);
  }

  &.isExpanded {
    transform: rotate(180deg);
  }
}

.separator {
  height: 1px;
  width: 100%;
  margin-top: 16px;
  background-color: var(--border-soft);
  border: none;
}

.mobileButtons {
  display: none;

  @include respond-to('max-sm') {
    display: block;
    width: 100%;
  }
}

.logoWrapper {
  width: 18px;
  height: 18px;
}

.backdrop {
  display: none;

  @include respond-to('max-sm') {
    display: none;
    position: fixed;
    inset: 0;
    background-color: var(--background-backdrop);
    z-index: calc(var(--z-index-sidebar) - 1);
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &.isExpanded {
      display: block;
    }
  }
}

.scheduleTaskContent {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.scheduleTaskBadge {
  @include typography-v2-ui-xs;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 20px;
  margin-left: auto;
  padding: 2px 8px;
  border: 1px solid var(--border-default);
  border-radius: 8px;
}

.emptyCategoryState {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin: 0;
  padding: 12px 8px;
}

.loadMoreSentinel {
  min-height: 1px;
}

.settingsTooltip {
  border-radius: 4px;
  padding: 4px 8px;
}

.shareButton {
  @include border-radius-r2;

  &:disabled {
    border: none;
  }
}

.settingsButton {
  @include border-radius-r2;
}

.scheduleTaskButton {
  @include border-radius-r2;
}
